<div class="pl-5 pt-5 pr-5 pb-3 pb-5"> 
  <h2 class="m-0 text--f20 text--500">{{ title }}</h2>
  <div class="pt-4">{{ message }}</div>
</div>